import { render, staticRenderFns } from "./CadastroPadrao.vue?vue&type=template&id=53b2e299"
import script from "./CadastroPadrao.vue?vue&type=script&lang=js"
export * from "./CadastroPadrao.vue?vue&type=script&lang=js"
import style0 from "./CadastroPadrao.vue?vue&type=style&index=0&id=53b2e299&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports